import { render, staticRenderFns } from "./AssistantSidebar.vue?vue&type=template&id=ad771338&scoped=true"
import script from "./AssistantSidebar.vue?vue&type=script&lang=js"
export * from "./AssistantSidebar.vue?vue&type=script&lang=js"
import style0 from "./AssistantSidebar.vue?vue&type=style&index=0&id=ad771338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad771338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
